// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kkoc","footer":"styles_footer__L73NO"};